import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UserNotificationSdk extends SdkBase {
	constructor(injector: Injector) { super(injector); }
	public get(): Observable<boolean> {
		return this.makeHttpRequest<boolean>('get', `api2/UserNotifications`);
	}
}
